var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter16X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 3.6C12.2 4.34558 11.5956 4.95 10.85 4.95C10.1044 4.95 9.5 4.34558 9.5 3.6C9.5 2.85442 10.1044 2.25 10.85 2.25C11.5956 2.25 12.2 2.85442 12.2 3.6ZM13.3681 4.25C13.0795 5.3714 12.0615 6.2 10.85 6.2C9.6385 6.2 8.62054 5.3714 8.33191 4.25H2.38379C2.03861 4.25 1.75879 3.97018 1.75879 3.625C1.75879 3.27982 2.03861 3 2.38379 3H8.31957C8.59044 1.85332 9.62057 1 10.85 1C12.0794 1 13.1096 1.85332 13.3804 3H15.1234C15.4686 3 15.7484 3.27982 15.7484 3.625C15.7484 3.97018 15.4686 4.25 15.1234 4.25L13.3681 4.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3 12.4C5.3 13.1456 5.90442 13.75 6.65 13.75C7.39558 13.75 8 13.1456 8 12.4C8 11.6544 7.39558 11.05 6.65 11.05C5.90442 11.05 5.3 11.6544 5.3 12.4ZM4.13191 13.05C4.42054 14.1714 5.4385 15 6.65 15C7.8615 15 8.87946 14.1714 9.16809 13.05H15.1328C15.478 13.05 15.7578 12.7702 15.7578 12.425C15.7578 12.0798 15.478 11.8 15.1328 11.8H9.18043C8.90956 10.6533 7.87943 9.79999 6.65 9.79999C5.42057 9.79999 4.39044 10.6533 4.11957 11.8H2.375C2.02982 11.8 1.75 12.0798 1.75 12.425C1.75 12.7702 2.02982 13.05 2.375 13.05H4.13191Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter16X16);
export default __webpack_public_path__ + "static/media/Filter16x16.5807c671ad4cb283858942dea90c6180.svg";
export { ForwardRef as ReactComponent };